import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { FormBuilder, Validators } from '@angular/forms'
import { CustomValidators } from 'ng2-validation'
import { Item } from '../../../../models'

@Component({
  selector: 'app-item-import-form-com',
  templateUrl: './item-import-form.com.html'
})

export class ItemImportFormComponent implements OnInit {

  @Input() skuId: number = null
  @Input() item: Item = null
  @Input() info = { batchNumbers: null, purchasers: null, locations: null, taxRates: null,
    dates: [(new Date()).toISOString().slice(0, 10)], commissionRates: ['0'], exchangeRates: ['1']
  }
  @Input() batchNumbers = [null]
  @Input() actionName = '入库'
  @Output() event = new EventEmitter()
  form = null

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.buildForm()
  }

  public submit(e) {
    e.preventDefault()
    const item = this.form.value
    item.purchase_date = item.purchase_date
    item.tax_rate = item.tax_rate / 100
    item.commission_rate = item.commission_rate / 100
    item.sku_id = this.skuId
    item.item_id = this.item ? this.item.item_id : null
    this.event.emit({ source: 'import-form', action: 'submit', data: item })
  }

  public cancel(e) {
    e.preventDefault()
    this.event.emit({ source: 'import-form', action: 'cancel' })
  }

  private buildForm() {
    this.form = this.fb.group({
      batch_number: [this.item ? this.item.batch_number : this.info.batchNumbers[0], Validators.required],
      purchaser: [this.item ? this.item.purchaser : this.info.purchasers[0], Validators.required],
      purchase_date: [this.item ? this.item.purchase_date : this.info.dates[0], Validators.required],
      location: [this.item ? this.item.location : this.info.locations[0], Validators.required],
      count: [this.item ? this.item.count : 1, Validators.compose([Validators.required, CustomValidators.min(0)])],
      pre_tax_price: [this.item ? this.item.pre_tax_price : '', Validators.compose([Validators.required, CustomValidators.min(0)])],
      tax_rate: [
        this.item ? Math.round(this.item.tax_rate * 10000) / 100 : +this.info.taxRates[0] * 100,
        Validators.compose([Validators.required, CustomValidators.min(0)])
      ],
      commission_rate: [
        this.item ? this.item.commission_rate * 100 : +this.info.commissionRates[0] * 100,
        Validators.compose([Validators.required, CustomValidators.min(0)])
      ],
      exchange_rate: [
        this.item ? this.item.exchange_rate : this.info.exchangeRates[0],
        Validators.compose([Validators.required, CustomValidators.min(0)])
      ],
      shipping_fee: [this.item ? this.item.shipping_fee : 0, Validators.compose([Validators.required, CustomValidators.min(0)])]
    })
  }

  public get cost() {
    return this.form.value.pre_tax_price *
      (1 + this.form.value.tax_rate / 100 + this.form.value.commission_rate / 100)
      * this.form.value.exchange_rate
      + this.form.value.shipping_fee
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/forms/item-import-form/item-import-form.com.ts